import { answerCards } from "./content";

export type ResumeDraft = {
  subtitle: string;
  body: string;
};

export function buildResumeDraft(prompt: string): ResumeDraft {
  const lower = prompt.toLowerCase();
  const subtitle = lower.includes("gaming")
    ? "Product Leader — Gaming AI, Cybersecurity & Platforms"
    : lower.includes("product leader")
      ? "Product Leader — Cybersecurity & AI"
      : "Product Leader — AI, Cybersecurity & Product";
  const template = answerCards.find((card) => card.id === "cv")?.answer.auto
    ?? "Omer Yoachimik\nProduct Leader — Cybersecurity & AI";
  const [, , ...body] = template.split("\n");
  return { subtitle, body: ["Omer Yoachimik", subtitle, ...body].join("\n") };
}
